import { apiHost } from './config'

let currentUserToken: null | string = null
let currentUserTokenExpiration: null | number = null

const api = (
  method: string,
  endpoint: string,
  data?: {},
  options?: {},
  headers?: {}
) => {
  const defaultHeaders = {
    'Content-Type': 'application/json',
  }
  if (currentUserToken && currentUserTokenExpiration) {
    if (Date.now() >= currentUserTokenExpiration * 1000) {
      currentUserToken = null
      currentUserTokenExpiration = null
    } else {
      defaultHeaders['Authorization'] = `Bearer ${currentUserToken}`
    }
  }

  return window
    .fetch(`${apiHost}/${endpoint}`, {
      method: method.toUpperCase(),
      headers: { ...defaultHeaders, ...headers },
      body: JSON.stringify(data),
      ...options,
    })
    .then((response) => {
      const { ok, status, url } = response

      if (ok) {
        return response.json().catch(() => {
          throw `Malformed JSON from ${endpoint}`
        })
      }

      if (url.match(/\/gatekeeper\//)) {
        return Promise.reject({
          status,
        })
      }

      if (status === 400)
        return response.json().then((error) => Promise.reject(error))

      return response
        .json()
        .catch(() => {
          throw `Malformed JSON from ${endpoint}`
        })
        .then(({ meta }) => {
          throw meta
        })
    })
}

type SetTokenProps = {
  accessToken: string | null
  expiresAt: number | null
}

export function setToken(
  { accessToken = null, expiresAt = null }: SetTokenProps = {
    accessToken: null,
    expiresAt: null,
  }
) {
  currentUserToken = accessToken
  currentUserTokenExpiration = expiresAt
}

export default api
